'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonation = exports.fetchDonationFeed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _compact = require('lodash/compact');

var _compact2 = _interopRequireDefault(_compact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var fetchDonationFeed = function fetchDonationFeed(options) {
  var includeOffline = options.includeOffline,
      fetchAll = options.fetchAll,
      params = _objectWithoutProperties(options, ['includeOffline', 'fetchAll']);

  var finalParams = _extends({}, params, {
    type: (0, _compact2.default)(['OnlineDonation', includeOffline && 'OfflineDonation'])
  });

  return fetchAll ? recursivelyFetchFeed(finalParams) : fetchFeed(finalParams).then(function (_ref) {
    var results = _ref.results;
    return results;
  });
};

exports.fetchDonationFeed = fetchDonationFeed;
var fetchFeed = function fetchFeed(params) {
  var mappings = {
    campaign: 'campaign_id',
    charity: 'charity_id',
    page: 'page_id',
    team: 'team_id',
    type: 'type',
    index: 'page'
  };

  return (0, _client.get)('api/v2/search/feed', params, { mappings: mappings });
};

var recursivelyFetchFeed = function recursivelyFetchFeed(params) {
  var feed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return fetchFeed(_extends({}, params, { index: index })).then(function (_ref2) {
    var results = _ref2.results,
        pagination = _ref2.meta.pagination;

    var updatedResults = [].concat(_toConsumableArray(feed), _toConsumableArray(results));
    var limit = params.limit || 50;

    return pagination.last_page || index >= limit ? updatedResults : recursivelyFetchFeed(params, updatedResults, index + 1);
  });
};

var deserializeDonation = exports.deserializeDonation = function deserializeDonation(donation) {
  return {
    amount: donation.amount.cents / 100,
    anonymous: donation.anonymous,
    createdAt: donation.created_at,
    currency: donation.amount.currency.iso_code,
    message: donation.message,
    name: donation.nickname,
    page: donation.page_id,
    reply: donation.thankyou_message
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/feeds/everydayhero/index.js
// module id = 1407
// module chunks = 0